import { render, staticRenderFns } from "./detail-management-edito.vue?vue&type=template&id=ec095032&scoped=true&"
import script from "./detail-management-edito.vue?vue&type=script&lang=js&"
export * from "./detail-management-edito.vue?vue&type=script&lang=js&"
import style0 from "./detail-management-edito.vue?vue&type=style&index=0&id=ec095032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec095032",
  null
  
)

export default component.exports